<template>
  <div v-resize="onResize" class="tab-items-row" style="padding: 0; margin: 0">
    <div v-if="hasAlternative" style="border-bottom: 1px solid #eee; margin-bottom: 15px">
      <v-layout wrap class="mb-2">
        <v-flex xs7 md9>
          <template v-if="input && input.randomStatus">
            {{ $t('Random chatbot answers') }}
          </template>
          <template v-else>
            {{ $t('Chatbot answers') }}
          </template>
        </v-flex>
        <v-flex xs5 md3 class="text-xs-right">
          <v-dialog v-model="showSetting" max-width="800" persistent>
            <v-card>
              <div class="text-xs-right">
                <v-btn small fab flat @click="showSetting = false"><v-icon>close</v-icon></v-btn>
              </div>
              <v-card-text class="text-xs-left">
                <div class="primary--text mt-3">
                  {{ $t('Random answer') }}
                </div>
                <label
                  class="toggle-switch small"
                  style="margin-top: 10px; margin-bottom: 10px; vertical-align: bottom"
                >
                  <input
                    type="checkbox"
                    :checked="input.randomStatus"
                    @change="toggleRandomStatus()"
                  />
                  <span class="toggle-slider lever round"></span>
                </label>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn color="primary" @click="changeSetting">
                  {{ $t('Save') }}
                </v-btn>
                <v-spacer />
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-btn
            v-if="$route.name != 'Setup'"
            class="ma-0 extra-small"
            fab
            flat
            small
            color="grey"
            @click="showSetting = true"
          >
            <v-icon>settings</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </div>
    <div ref="randomBar"></div>
    <template v-if="input && input.randomStatus">
      <!-- Random Intent -->
      <v-layout class="mb-2 primary lighten-4">
        <v-flex>
          <v-tabs
            v-model="currentAlternative"
            :show-arrows="true"
            color="primary lighten-4"
            slider-color="primary"
            :style="{ 'max-width': maxRandomBarWidth + 'px' }"
          >
            <v-tab v-for="n in intentItems.length" :key="n" ripple>
              {{ $t('pattern') }} {{ n }}
              <v-btn
                :disabled="intentItems.length == 1"
                fab
                flat
                small
                class="mr-0"
                style="width: 25px; height: 25px"
                @click="onDeleteAlternative(n)"
              >
                <v-icon small>close</v-icon>
              </v-btn>
            </v-tab>
          </v-tabs>
        </v-flex>
        <v-flex ref="addRandomBtn" shrink style="min-width: 48px">
          <v-btn
            v-tooltip.top="$t('In case, user wants to random reply messages')"
            class="extra-small mt-2"
            fab
            small
            outline
            color="black"
            :disabled="intentItems.length >= 5"
            @click="nextAlternative"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </template>
    <div class="mt-2"></div>

    <v-window v-model="currentAlternative">
      <v-window-item v-for="i in intentItems.length" :key="`${i}_${randomTimestamp}`">
        <div v-for="(comment, index) in intentItems[i - 1]" :key="'comment_' + i + '_' + index">
          <v-checkbox
            v-model="intentItems[i - 1][index].replyinbox"
            :label="$t('Reply to inbox')"
            color="primary"
            hide-details
            style="margin-top: 0; margin-bottom: 5px"
            @change="onCheckboxChange"
          ></v-checkbox>
          <!-- reply to inbox -->
          <template v-if="intentItems[i - 1][index].responseinbox">
            <div
              style="
                width: 20px;
                min-width: 20px;
                display: inline-block;
                float: left;
                margin-right: 10px;
              "
            >
              &nbsp;
            </div>
            <template
              v-if="
                intentItems[i - 1][index].responseinbox &&
                intentItems[i - 1][index].responseinbox.length > 0
              "
            >
              <template v-if="intentItems[i - 1][index].responseinbox[0].type == 'text'">
                <div
                  class="message"
                  style="
                    float: left;
                    position: relative;
                    border-radius: 12px;
                    max-width: 281px;
                    overflow-wrap: break-word;
                    min-height: 22px;
                    min-width: 14px;
                    line-height: 15.36px;
                    overflow: hidden;
                    cursor: pointer;
                  "
                >
                  <div style="font-size: 12px; color: black">
                    <div style="padding: 8px 6px 2px; background-color: #f1f0f0">
                      <div
                        class="form-control"
                        :class="{
                          'has-error': errors.has(
                            'answer_' + (currentAlternative - 1) + '_text_' + index
                          )
                        }"
                      >
                        <autoresize-textarea
                          :ref="'answer_' + (currentAlternative - 1) + '_' + index"
                          v-model="intentItems[i - 1][index].responseinbox[0].text"
                          v-validate
                          maxlength="1900"
                          class
                          :placeholder="$t('Chatbot answers')"
                          name="answer"
                          data-vv-as="Answer"
                          :data-vv-name="'answer_' + (currentAlternative - 1) + '_text_' + index"
                          style="resize: none; display: inherit; margin-bottom: 5px"
                        ></autoresize-textarea>
                        <v-layout>
                          <v-flex class="error--text">
                            <span
                              v-show="
                                errors.has('answer_' + (currentAlternative - 1) + '_text_' + index)
                              "
                              class="text-error"
                              >{{
                                errors.first(
                                  'answer_' + (currentAlternative - 1) + '_text_' + index
                                )
                              }}
                            </span>
                          </v-flex>
                          <v-flex shrink class="text-xs-right caption grey--text">
                            {{ intentItems[i - 1][index].responseinbox[0].text.length }} / 1900
                          </v-flex>
                        </v-layout>
                      </div>
                    </div>
                  </div>

                  <div class="clearfix"></div>
                </div>

                <intent-prefill
                  @addIntentPrefill="addIntentPrefill(currentAlternative - 1, index, $event)"
                ></intent-prefill>
              </template>
              <template
                v-if="
                  ['removeandaddtocart', 'addtocart', 'removetocart'].includes(
                    intentItems[i - 1][index].responseinbox[0].type
                  )
                "
              >
                <span>
                  <view-cart-summary-viewer2 :items="item.data"></view-cart-summary-viewer2>
                </span>
                <span>
                  <div>
                    <v-tooltip bottom>
                      <template #activator="{ on }">
                        <v-btn
                          fab
                          outline
                          color="primary"
                          class="extra-small"
                          v-on="on"
                          @click="editRemoveAndAdd(item, 0)"
                        >
                          <em class="fa fa-pencil-alt middle" />
                        </v-btn>
                      </template>
                      <span>{{ $t('edit') }}</span>
                    </v-tooltip>
                  </div>
                </span>
              </template>
              <template v-if="intentItems[i - 1][index].responseinbox[0].type == 'button'">
                <div
                  class="message"
                  style="
                    float: left;
                    position: relative;
                    border-radius: 12px;
                    max-width: 281px;
                    overflow-wrap: break-word;
                    min-height: 22px;
                    min-width: 14px;
                    line-height: 15.36px;
                  "
                >
                  <div style="font-size: 12px; color: black">
                    <div
                      style="
                        padding: 8px 6px 2px;
                        background-color: #f1f0f0;
                        border-top-left-radius: 10px;
                        border-top-right-radius: 10px;
                      "
                    >
                      <div
                        class="form-control"
                        :class="{
                          'has-error': errors.has(
                            'answer_' + (currentAlternative - 1) + '_text_' + index
                          )
                        }"
                      >
                        <autoresize-textarea
                          :ref="'answer_' + (currentAlternative - 1) + '_' + index"
                          v-model="intentItems[i - 1][index].responseinbox[0].text"
                          v-validate
                          maxlength="640"
                          class
                          :placeholder="$t('Chatbot answers')"
                          name="answer"
                          data-vv-as="Answer"
                          :data-vv-name="'answer_' + (currentAlternative - 1) + '_text_' + index"
                          style="resize: none; display: inherit; margin-bottom: 5px"
                        ></autoresize-textarea>

                        <v-layout>
                          <v-flex class="error--text">
                            <span
                              v-show="
                                errors.has('answer_' + (currentAlternative - 1) + '_text_' + index)
                              "
                              class="text-error"
                              >{{
                                errors.first(
                                  'answer_' + (currentAlternative - 1) + '_text_' + index
                                )
                              }}</span
                            >
                          </v-flex>
                          <v-flex shrink class="text-xs-right caption grey--text">
                            {{ intentItems[i - 1][index].responseinbox[0].text.length }}/640
                          </v-flex>
                        </v-layout>
                      </div>
                    </div>
                  </div>

                  <div class="clearfix"></div>
                  <div
                    style="
                      float: left;
                      width: 100%;
                      border: 1px solid #eee;
                      border-bottom-left-radius: 12px;
                      border-bottom-right-radius: 12px;
                    "
                  >
                    <ul class="message-group message-group-flush" style="margin-bottom: 0px">
                      <template
                        v-if="
                          intentItems[i - 1][index].responseinbox[0].buttons &&
                          intentItems[i - 1][index].responseinbox[0].buttons.length > 0
                        "
                      >
                        <li
                          v-for="(button, bindex) in intentItems[i - 1][index].responseinbox[0]
                            .buttons"
                          :key="bindex"
                          class="message-group-item"
                          style="
                            position: relative;
                            border-left: none;
                            border-right: none;
                            border-bottom: none;
                            border-radius: 0px;
                            text-align: center;
                            padding: 5px 10px;
                          "
                          :style="{ 'border-top': bindex != 0 ? '1px solid #eee' : 'none' }"
                        >
                          <add-generic-button
                            :key="'comment_button_' + index + '_' + bindex + '_' + editTimestamp"
                            v-model="intentItems[i - 1][index].responseinbox[0].buttons[bindex]"
                            :is-edit="true"
                            @onSave="editButton(index, bindex, $event)"
                          >
                            <div slot="body" class="text-xs-center">
                              <span style="color: #0084ff" :title="button.title">{{
                                button.title | truncate(12)
                              }}</span>
                            </div>

                            <template slot="append">
                              <v-list-tile
                                :disabled="bindex <= 0"
                                @click="
                                  onMoveButton(
                                    bindex,
                                    'up',
                                    intentItems[i - 1][index].responseinbox[0]
                                  )
                                "
                              >
                                <v-list-tile-title
                                  :style="bindex <= 0 ? `color: lightgrey` : ''"
                                  class="primary-color"
                                  >{{ $t('Move up') }}</v-list-tile-title
                                >
                              </v-list-tile>
                              <v-list-tile
                                :disabled="
                                  bindex >=
                                  intentItems[i - 1][index].responseinbox[0].buttons.length - 1
                                "
                                @click="
                                  onMoveButton(
                                    bindex,
                                    'down',
                                    intentItems[i - 1][index].responseinbox[0]
                                  )
                                "
                              >
                                <v-list-tile-title
                                  :style="
                                    bindex >=
                                    intentItems[i - 1][index].responseinbox[0].buttons.length - 1
                                      ? `color: lightgrey`
                                      : ''
                                  "
                                  class="primary-color"
                                  >{{ $t('Move down') }}</v-list-tile-title
                                >
                              </v-list-tile>
                              <v-list-tile @click="deleteButton(index, bindex)">
                                <v-list-tile-title class="primary-color">{{
                                  $t('Delete')
                                }}</v-list-tile-title>
                              </v-list-tile>
                            </template>
                          </add-generic-button>
                          <div class="clearfix"></div>

                          <div style="margin: 0; font-size: 10px">
                            <span v-if="button.type == 'web_url'" :title="button.url">{{
                              button.url | truncate(20)
                            }}</span>
                            <span v-else-if="button.type == 'postback'" :title="button.payload">{{
                              button.payload | truncate(20)
                            }}</span>
                            <span
                              v-else-if="button.type == 'phone_number'"
                              :title="button.payload"
                              >{{ button.payload | truncate(20) }}</span
                            >
                            <span v-else>&nbsp;</span>
                          </div>
                        </li>
                      </template>
                      <li
                        v-if="
                          intentItems[i - 1][index].responseinbox[0].buttons &&
                          intentItems[i - 1][index].responseinbox[0].buttons.length < 3
                        "
                        class="message-group-item"
                        style="
                          border-left: none;
                          border-right: none;
                          border-bottom: none;
                          border-radius: 0px;
                          text-align: center;
                          padding: 10px 0px;
                        "
                        :style="{
                          'border-top':
                            intentItems[i - 1][index].responseinbox[0].buttons.length != 0
                              ? '1px solid #eee'
                              : 'none'
                        }"
                      >
                        <add-generic-button
                          :key="'comment_new_button_' + saveTimestamp"
                          v-model="newButton"
                          @onSave="addNewButton(index, $event)"
                        >
                          <template slot="body">
                            <span class="fas fa-plus"></span>
                            {{ $t('Add button') }}
                          </template>
                        </add-generic-button>
                      </li>
                    </ul>
                  </div>
                  <input
                    v-model="intentItems[i - 1][index].responseinbox[0].buttons.length"
                    v-validate="''"
                    type="hidden"
                    :name="'answer_' + (currentAlternative - 1) + '_buttons_' + index"
                    data-vv-as="Buttons"
                  />
                  <div
                    class="form-control"
                    :class="{
                      'has-error': errors.has(
                        'answer_' + (currentAlternative - 1) + '_buttons_' + index
                      )
                    }"
                  >
                    <span
                      v-show="
                        errors.has('answer_' + (currentAlternative - 1) + '_buttons_' + index)
                      "
                      class="text-error"
                      >{{
                        errors.first('answer_' + (currentAlternative - 1) + '_buttons_' + index)
                      }}</span
                    >
                  </div>
                </div>
                <intent-prefill
                  @addIntentPrefill="addIntentPrefill(currentAlternative - 1, index, $event)"
                ></intent-prefill>
              </template>
              <template v-else-if="intentItems[i - 1][index].responseinbox[0].type == 'image'">
                <div
                  :ref="'answer_' + (currentAlternative - 1) + '_' + index"
                  class="message"
                  style="
                    float: left;
                    position: relative;
                    border-radius: 12px;
                    width: 181px;
                    overflow-wrap: break-word;
                    min-height: 22px;
                    min-width: 14px;
                    line-height: 15.36px;
                    overflow: hidden;
                  "
                >
                  <uploadfile
                    ref="answer"
                    v-model="intentItems[i - 1][index].responseinbox[0].image_url"
                    v-validate
                    :height="181"
                    data-vv-as="Image"
                    :data-vv-name="'answer_' + (currentAlternative - 1) + '_image_' + index"
                  ></uploadfile>
                </div>
                <div class="clearfix"></div>
              </template>
              <template v-else-if="intentItems[i - 1][index].responseinbox[0].type == 'video'">
                <div
                  :ref="'answer_' + (currentAlternative - 1) + '_' + index"
                  class="message"
                  style="
                    min-height: 150px;
                    border: 1px solid #eee;
                    float: left;
                    position: relative;
                    border-radius: 12px;
                    width: 181px;
                    overflow-wrap: break-word;
                    min-height: 22px;
                    min-width: 14px;
                    line-height: 15.36px;
                    overflow: hidden;
                  "
                >
                  <template v-if="intentItems[i - 1][index].responseinbox[0].picture">
                    <v-img
                      :src="intentItems[i - 1][index].responseinbox[0].picture"
                      :aspect-ratio="16 / 9"
                      color="grey"
                    ></v-img>
                  </template>
                  <template v-else>
                    <v-responsive :aspect-ratio="16 / 9">
                      <div style="background: #eee; height: 100%"></div>
                    </v-responsive>
                  </template>

                  <v-layout
                    fill-height
                    absolute
                    class="text-xs-center"
                    style="top: 0; bottom: 0; position: absolute; left: 0; right: 0"
                  >
                    <div
                      style="margin: auto; width: 100%"
                      :title="intentItems[i - 1][index].responseinbox[0].source"
                      :alt="intentItems[i - 1][index].responseinbox[0].source"
                    >
                      <v-btn fab small depressed color="white">
                        <v-icon large>play_circle_filled</v-icon>
                      </v-btn>
                    </div>
                  </v-layout>
                </div>
                <div class="clearfix"></div>
              </template>
              <template v-else-if="intentItems[i - 1][index].responseinbox[0].type == 'generic'">
                <intent-generic-manage
                  v-model="intentItems[i - 1][index].responseinbox[0].data"
                  @deleteMessage="onDelete(index)"
                ></intent-generic-manage>
              </template>
              <template
                v-else-if="intentItems[i - 1][index].responseinbox[0].type == 'ntn_template'"
              >
                <intent-ntn-manage
                  v-model="intentItems[i - 1][index].responseinbox[0]"
                  :ratio="intentItems[i - 1][index].responseinbox[0].ratio"
                  @changeRatio="changeRatio(index, $event)"
                  @deleteMessage="onDelete(index)"
                ></intent-ntn-manage>
              </template>
              <template v-else-if="intentItems[i - 1][index].responseinbox[0].type == 'flex'">
                <intent-line-flex
                  v-model="intentItems[i - 1][index].responseinbox[0].contents"
                  @deleteMessage="onDelete(index)"
                ></intent-line-flex>
              </template>
              <template
                v-else-if="intentItems[i - 1][index].responseinbox[0].type == 'product_catalog'"
              >
                <intent-product-catalog
                  v-model="intentItems[i - 1][index].responseinbox[0]"
                  :is-reply-comment="
                    intentItems[i - 1][index].responseinbox[0].product_catalog_message.type ===
                    'add_product_by_bot'
                      ? false
                      : true
                  "
                  @deleteMessage="onDelete(index)"
                ></intent-product-catalog>
              </template>

              <div class="clearfix"></div>
              <div for class="caption mt-3 mb-2">{{ $t('Select reply type') }}</div>
              <div style="overflow-x: auto">
                <ul class="customize-message-tool">
                  <li
                    :class="{ active: intentItems[i - 1][index].responseinbox[0].type == 'text' }"
                    @click="selectIntentReplyType('text')"
                  >
                    <vue-simple-svg
                      :filepath="'/static/img/assets/get_started/add-speech-bubble.svg'"
                      width="40px"
                      height="40px"
                      class="img"
                    />
                    {{ $t('Message') }}
                  </li>
                  <li
                    :class="{
                      inactive: $store.getters.getPackage != 'premium',
                      active: intentItems[i - 1][index].responseinbox[0].type == 'button'
                    }"
                    @click="selectIntentReplyType('button')"
                  >
                    <vue-simple-svg
                      :filepath="'/static/img/assets/get_started/add-button.svg'"
                      width="40px"
                      height="40px"
                      class="img"
                    />
                    {{ $t('Button') }}
                    <div style="position: absolute; left: 0; right: 5px; top: 0; text-align: right">
                      <v-premium-lock :inline="true"></v-premium-lock>
                    </div>
                  </li>
                  <li
                    :class="{
                      inactive: $store.getters.getPackage != 'premium',
                      active: intentItems[i - 1][index].responseinbox[0].type == 'image'
                    }"
                    @click="selectIntentReplyType('image')"
                  >
                    <vue-simple-svg
                      :filepath="'/static/img/assets/get_started/add-image.svg'"
                      width="40px"
                      height="40px"
                      class="img"
                    />
                    {{ $t('Image') }}
                    <div style="position: absolute; left: 0; right: 5px; top: 0; text-align: right">
                      <v-premium-lock :inline="true"></v-premium-lock>
                    </div>
                  </li>
                  <li
                    :class="{
                      inactive: $store.getters.getPackage != 'premium',
                      active: intentItems[i - 1][index].responseinbox[0].type == 'generic'
                    }"
                    @click="selectIntentReplyType('generic')"
                  >
                    <vue-simple-svg
                      :filepath="'/static/img/assets/get_started/add-menu_list.svg'"
                      width="40px"
                      height="40px"
                      class="img"
                    />
                    {{ $t('Menu list') }}
                    <div style="position: absolute; left: 0; right: 5px; top: 0; text-align: right">
                      <v-premium-lock :inline="true"></v-premium-lock>
                    </div>
                  </li>
                  <li
                    v-if="
                      !isLiveStream &&
                      ['thailandpostmart'].includes(selectedBot.type) &&
                      !['{default}', '{default_comment_to_inbox}'].includes(intentname)
                    "
                    style="backround-color: grey"
                    :class="{
                      inactive: $store.getters.getPackage != 'premium',
                      active: intentItems[i - 1][index].responseinbox[0].type == 'cartaddremove'
                    }"
                    @click="selectIntentReplyType('addtocart')"
                  >
                    <vue-simple-svg
                      :filepath="'/static/img/assets/get_started/add-cart.svg'"
                      width="40px"
                      height="40px"
                      class="img"
                    />
                    {{ $t('Add/Remove to cart') }}
                    <div style="position: absolute; left: 0; right: 5px; top: 0; text-align: right">
                      <v-premium-lock :inline="true"></v-premium-lock>
                    </div>
                  </li>
                  <li
                    :class="{
                      inactive: $store.getters.getPackage != 'premium',
                      active: intentItems[i - 1][index].responseinbox[0].type == 'video'
                    }"
                    @click="selectIntentReplyType('video')"
                  >
                    <vue-simple-svg
                      :filepath="'/static/img/assets/get_started/add-video.svg'"
                      width="40px"
                      height="40px"
                      class="img"
                    />
                    {{ $t('Video') }}
                    <div style="position: absolute; left: 0; right: 5px; top: 0; text-align: right">
                      <v-premium-lock :inline="true"></v-premium-lock>
                    </div>
                  </li>
                  <li
                    v-if="$store.state.ntnPage.includes(selectedBot.pageid)"
                    :class="{
                      active: intentItems[i - 1][index].responseinbox[0].type == 'ntn_template'
                    }"
                    @click="selectIntentReplyType('ntn_template')"
                  >
                    <vue-simple-svg
                      :filepath="'/static/img/assets/get_started/add-speech-bubble.svg'"
                      width="40px"
                      height="40px"
                      class="img"
                    />
                    {{ $t('allow_recurring_notification') }}
                    <!-- <div style="position: absolute; left: 0; right: 5px; top: 0; text-align: right">
                      <v-premium-lock :inline="true"></v-premium-lock>
                    </div> -->
                  </li>
                  <li
                    v-if="isActiveManageProductToCart"
                    :class="{
                      inactive: $store.getters.getPackage != 'premium',
                      active:
                        intentItems[i - 1][index].responseinbox[0].type === 'product_catalog' &&
                        intentItems[i - 1][index].responseinbox[0].product_catalog_message.type ==
                          'management_product_to_cart_comment'
                    }"
                    @click="
                      () => {
                        isReplyComment = true
                        selectIntentReplyType('manage_product_to_cart')
                      }
                    "
                  >
                    <vue-simple-svg
                      :filepath="'/static/img/assets/get_started/add-cart.svg'"
                      width="40px"
                      height="40px"
                      class="img"
                    />
                    {{ $t('Add/Remove to cart') }}
                    <div style="position: absolute; left: 0; right: 5px; top: 0; text-align: right">
                      <v-premium-lock :inline="true"></v-premium-lock>
                    </div>
                  </li>
                  <li
                    v-if="isActiveProductCatalog"
                    :class="{
                      inactive: $store.getters.getPackage != 'premium',
                      active:
                        intentItems[i - 1][index].responseinbox[0].type === 'product_catalog' &&
                        intentItems[i - 1][index].responseinbox[0].product_catalog_message.type ==
                          'add_product_by_bot'
                    }"
                    @click="selectIntentReplyType('product_catalog')"
                  >
                    <vue-simple-svg
                      :filepath="'/static/img/assets/get_started/add-menu_list.svg'"
                      width="40px"
                      height="40px"
                      class="img"
                    />
                    {{ $t('product_catalog.title') }}
                    <div style="position: absolute; left: 0; right: 5px; top: 0; text-align: right">
                      <v-premium-lock :inline="true"></v-premium-lock>
                    </div>
                  </li>
                </ul>
              </div>
            </template>
          </template>
          <div class="clearfix"></div>

          <div class="hr"></div>
          <v-checkbox
            v-model="intentItems[i - 1][index].replycomment"
            :label="$t('Reply to comment')"
            color="primary"
            hide-details
            style="margin-top: 0; margin-bottom: 5px"
            @change="onReplyComment(i - 1, index, $event)"
          ></v-checkbox>
          <template v-if="intentItems[i - 1][index].replycomment">
            <template
              v-if="
                intentItems[i - 1][index].responsecomment &&
                intentItems[i - 1][index].responsecomment.length > 0
              "
            >
              <div
                style="
                  width: 20px;
                  min-width: 20px;
                  display: inline-block;
                  float: left;
                  margin-right: 10px;
                "
              >
                &nbsp;
              </div>
              <div
                class="message"
                style="
                  margin-bottom: 10px;
                  float: left;
                  position: relative;
                  border-radius: 12px;
                  max-width: 281px;
                  overflow-wrap: break-word;
                  min-height: 22px;
                  min-width: 14px;
                  line-height: 15.36px;
                  overflow: hidden;
                  cursor: pointer;
                "
              >
                <div style="font-size: 12px; color: black">
                  <div style="padding: 5px 8px 6px; background-color: #f1f0f0">
                    <div
                      class="form-control"
                      :class="{ 'has-error': errors.has('answer_reply_comment') }"
                    >
                      <autoresize-textarea
                        :ref="'replyComment'"
                        v-model="intentItems[i - 1][index].responsecomment[0].text"
                        v-validate="''"
                        class="form-control"
                        placeholder="Answer"
                        name="answer"
                        data-vv-as="Answer"
                        :data-vv-name="'answer_reply_comment'"
                        style="resize: none"
                        :maxlength="replyCommentMaxLength"
                      ></autoresize-textarea>
                      <v-layout>
                        <v-flex class="error--text">
                          <span v-show="errors.has('answer_reply_comment')" class="text-error">{{
                            errors.first('answer_reply_comment')
                          }}</span>
                        </v-flex>
                        <v-flex shrink class="text-xs-right caption grey--text">
                          {{ intentItems[i - 1][index].responsecomment[0].text.length }}/{{
                            replyCommentMaxLength
                          }}
                        </v-flex>
                      </v-layout>
                    </div>
                  </div>
                </div>
              </div>
              <div class="clearfix"></div>
              <template
                v-if="
                  intentItems[i - 1][index].responsecomment[0].image_url ||
                  intentItems[i - 1][index].responsecomment[0].image_url == ''
                "
              >
                <div
                  style="
                    width: 20px;
                    min-width: 20px;
                    display: inline-block;
                    float: left;
                    margin-right: 10px;
                  "
                >
                  <a
                    href="javascript:void(0);"
                    style="float: left; margin-left: 5px"
                    @click="deleteImage(i - 1, index)"
                  >
                    <em class="fas fa-trash" />
                  </a>
                </div>
                <div
                  :ref="'answer_' + i"
                  class="message"
                  style="
                    float: left;
                    position: relative;
                    border-radius: 12px;
                    width: 181px;
                    overflow-wrap: break-word;
                    min-height: 22px;
                    min-width: 14px;
                    line-height: 15.36px;
                    overflow: hidden;
                  "
                >
                  <uploadfile
                    ref="answer"
                    v-model="intentItems[i - 1][index].responsecomment[0].image_url"
                    v-validate
                    :height="181"
                    data-vv-as="Image"
                    :data-vv-name="'replycomment_' + i + '_image_' + index"
                  ></uploadfile>
                </div>
                <div class="clearfix"></div>
              </template>
              <template v-else>
                <div>
                  <label for>{{ $t('Add more item') }}</label>
                  <ul class="customize-message-tool">
                    <li @click="addImage(i - 1, index)">
                      <vue-simple-svg
                        :filepath="'/static/img/assets/get_started/add-image.svg'"
                        width="40px"
                        height="40px"
                        class="img"
                      />
                      {{ $t('Image') }}
                    </li>
                  </ul>
                </div>
              </template>
            </template>
          </template>

          <div class="clearfix"></div>
          <div class="hr" style="margin-top: 10px"></div>
          <v-checkbox
            v-model="intentItems[i - 1][index].hidecomment"
            :label="$t('Hide comment')"
            color="primary"
            hide-details
            style="margin-top: 0; margin-bottom: 5px"
            @change="onHideComment(i - 1, index, $event)"
          ></v-checkbox>

          <template v-if="['tdtawandang'].includes(selectedBot.theme)">
            <div class="clearfix"></div>
            <div class="hr" style="margin-top: 10px"></div>
            <v-checkbox
              v-model="intentItems[i - 1][index].is_like_comment"
              :label="$t('Like this Comment')"
              color="primary"
              hide-details
              style="margin-top: 0; margin-bottom: 5px"
              @change="onLikeComment(i - 1, index, $event)"
            ></v-checkbox>
          </template>
        </div>
      </v-window-item>
    </v-window>

    <v-dialog v-model="showLineFlex" width="1000">
      <v-card>
        <v-layout>
          <v-flex>
            <div class="primary--text headline pa-2">Line Flex Message</div>
          </v-flex>
          <v-flex>
            <div class="text-xs-right">
              <v-btn flat fab small @click="cancelAddFlexMessage">
                <v-icon>close</v-icon>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>

        <v-card-text v-if="flexMessage">
          <intent-line-flex-message v-model="flexMessage.contents"></intent-line-flex-message>
        </v-card-text>

        <v-card-text class="text-xs-center">
          <v-btn outline color="grey" @click="cancelAddFlexMessage">{{ $t('Cancel') }}</v-btn>
          <v-btn depressed color="primary" @click="saveAddFlexMessage">{{ $t('Save') }}</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>

    <modal-video v-model="showVideo" @onAddVideo="addVideo"></modal-video>
    <v-dialog v-model="showCartaddremove" scrollable max-width="800">
      <IntentCartAddRemove
        v-if="showCartaddremove"
        :data="showCartaddremoveTemp"
        @addIntentItem="addIntentItem"
        @updateRemoveAndAdd="updateRemoveAndAdd($event)"
        @close="closecartaddremove"
      ></IntentCartAddRemove>
    </v-dialog>

    <ModalProductCatalog
      v-model="showProductCatalogMessage"
      :is-reply-comment="isReplyComment"
      @addProductCatalog="handleAddProductCatalog"
      @onCancelProductCatalog="handleCancelProductCatalog"
    ></ModalProductCatalog>
  </div>
</template>

<script>
import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea'
import uploadfile from '@/components/elements/uploadfile'
import ViewCartSummaryViewer2 from '@/components/elements/ViewCartSummaryViewer2'
import AddGenericButton from '@/components/view/chatbot/AddGenericButton'
import moment from 'moment'
import { mapGetters } from 'vuex'
import IntentCartAddRemove from './IntentCartAddRemove.vue'
import IntentGenericManage from './IntentGenericManage'
import IntentLineFlex from './IntentLineFlex'
import IntentLineFlexMessage from './IntentLineFlexMessage'
import IntentNtnManage from './IntentNtnManage'
import IntentPrefill from './IntentPrefill'
import ModalVideo from './ModalVideo'
import cloneDeep from 'lodash/cloneDeep'
import IntentProductCatalog from './IntentProductCatalog'
import ModalProductCatalog from './ModalProductCatalog'

export default {
  components: {
    AutoresizeTextarea,
    uploadfile,
    ModalVideo,
    IntentLineFlexMessage,
    IntentLineFlex,
    AddGenericButton,
    IntentGenericManage,
    IntentPrefill,
    IntentNtnManage,
    IntentCartAddRemove,
    ViewCartSummaryViewer2,
    ModalProductCatalog,
    IntentProductCatalog
  },
  props: {
    value: {
      default: ''
    },
    hasAlternative: {
      default: true,
      type: Boolean
    },
    isLiveStream: {
      default: false,
      type: Boolean
    },
    intentname: {
      default: ''
    }
  },
  data: function () {
    return {
      input: {
        showMultipleChannel: false,
        randomStatus: false
      },
      showSetting: false,
      showCartaddremove: false,
      showCartaddremoveTemp: '',
      currentReplyInboxType: 'text',
      group: '',
      item: {},
      intentItems: [],
      currentAlternative: 0,
      newComment: {
        type: 'responsepost',
        replyinbox: true,
        replycomment: false,
        hidecomment: false,
        likecomment: false,
        responseinbox: [
          {
            type: 'text',
            text: ''
          }
        ],
        responsecomment: [
          {
            type: 'text',
            text: ''
          }
        ]
      },

      showVideo: false,
      showLineFlex: false,
      showProductCatalogMessage: false,
      flexMessage: undefined,
      newButton: {
        title: '',
        type: 'web_url',
        url: ''
      },
      editTimestamp: moment().format('x'),
      saveTimestamp: moment().format('x'),
      timestamp: moment().format('x'),
      randomTimestamp: moment().format('x'),
      maxRandomBarWidth: 0,
      replyCommentMaxLength: 2000,
      isReplyComment: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      products: 'getProducts',
      welcomeMessage: 'welcomeMessage'
    }),
    isThailandPostMart() {
      return ['thailandpostmart'].includes(this.selectedBot.type)
    },
    isActiveProductCatalog() {
      return (
        ['cds'].includes(this.selectedBot.type) ||
        ['central-cds'].includes(this.selectedBot.page_group)
      )
    },
    isActiveManageProductToCart() {
      return (
        ['cds'].includes(this.selectedBot.type) ||
        ['central-cds'].includes(this.selectedBot.page_group)
      )
    }
  },
  watch: {
    value: {
      handler() {
        this.handleInitial()
      },
      deep: true
    }
  },

  created: function () {
    this.handleInitial()
  },
  methods: {
    handleInitial() {
      const vm = this

      vm.group = vm.value
      vm.intentItems = vm.group
      if (this.intentItems.length > 1) this.input.randomStatus = true
      if (
        vm.intentItems &&
        vm.intentItems[0] &&
        vm.intentItems[0][0] &&
        vm.intentItems[0][0].responseinbox
      ) {
        vm.item = vm.intentItems[0][0].responseinbox[0]
      }
      if (vm.intentItems[0].length === 0) {
        vm.intentItems[0][0] = vm.newComment
      }
      this.resetFlexMessage()
      this.onResize()
    },
    onResize() {
      if (this.$refs.randomBar) {
        let randomBarWidth = this.$refs.randomBar.clientWidth
        let addRandomBtnWidth = 48
        this.maxRandomBarWidth = randomBarWidth - addRandomBtnWidth
      }
    },
    onDeleteAlternative(alternative) {
      if (this.intentItems.length > 1) {
        // this.currentAlternative = this.currentAlternative != 1 ? this.currentAlternative - 1 : 1
        this.intentItems.splice(alternative - 1, 1)
      }
      this.timestamp = moment().format('x')
    },
    toggleRandomStatus() {
      this.input.randomStatus = !this.input.randomStatus
    },
    async changeSetting() {
      this.$emit('changeSetting', this.input)
      this.showSetting = false
      this.onResize()
    },
    onMoveButton: function (index, direction, item) {
      var vm = this

      if (direction == 'up') {
        item.buttons.splice(index, 0, item.buttons.splice(index - 1, 1)[0])
      } else if (direction == 'down') {
        item.buttons.splice(index, 0, item.buttons.splice(index + 1, 1)[0])
      }

      vm.$emit('input', vm.bubbleMessages)
    },
    addIntentItem(optype, { obj, checkstock, checksameproductincarts, adjuststock }) {
      var vm = this
      var mytext = obj.map((el) => `{"pid":${el.pid},"qty":${el.qty},"option":"${el.option}"}`)
      this.item = {
        data: obj,
        type: optype,
        index: 0,
        checkstock: checkstock,
        checksameproductincarts: checksameproductincarts,
        adjuststock: adjuststock
      }

      if (this.isThailandPostMart) {
        vm.$set(vm.intentItems[vm.currentAlternative][0].responseinbox, 0, {
          text: {
            addtocart: '{thailandpostmart_add_cart}',
            removetocart: '{thailandpostmart_remove_cart}',
            removeandaddtocart: '{thailandpostmart_checkout_cart}'
          }[optype],
          type: optype,
          data: obj,
          checkstock: checkstock,
          checksameproductincarts: checksameproductincarts,
          adjuststock: adjuststock
        })
      } else {
        vm.$set(vm.intentItems[vm.currentAlternative][0].responseinbox, 0, {
          text: `{${optype}([${mytext}])}`,
          type: optype,
          data: obj,
          checkstock: checkstock,
          checksameproductincarts: checksameproductincarts,
          adjuststock: adjuststock
        })
      }

      //
    },
    closecartaddremove() {
      this.showCartaddremove = false
    },
    cartaddremove() {
      this.showCartaddremoveTemp = ''
      this.showCartaddremove = true
    },
    editRemoveAndAdd(item, index) {
      this.showCartaddremoveTemp = {
        input: [...item.data],
        type: item.type,
        index,
        checksameproductincarts: item.checksameproductincarts,
        checkstock: item.checkstock,
        adjuststock: item.adjuststock
      }

      this.showCartaddremove = true
    },
    updateRemoveAndAdd(obj) {
      var vm = this
      var mytext = obj.data.map((el) => `{"pid":${el.pid},"qty":${el.qty},"option":"${el.option}"}`)
      if (this.isThailandPostMart) {
        vm.$set(vm.intentItems[vm.currentAlternative][0].responseinbox, 0, {
          text: {
            addtocart: '{thailandpostmart_add_cart}',
            removetocart: '{thailandpostmart_remove_cart}',
            removeandaddtocart: '{thailandpostmart_checkout_cart}'
          }[obj.type],
          type: obj.type,
          data: obj.data,
          checkstock: obj.checkstock,
          checksameproductincarts: obj.checksameproductincarts,
          adjuststock: obj.adjuststock
        })
      } else {
        vm.$set(vm.intentItems[vm.currentAlternative][0].responseinbox, 0, {
          text: `{${obj.type}([${mytext}])}`,
          type: obj.type,
          data: obj.data,
          checkstock: obj.checkstock,
          checksameproductincarts: obj.checksameproductincarts,
          adjuststock: obj.adjuststock
        })
      }
      vm.showCartaddremoveTemp = {
        input: [...obj.data],
        type: obj.type,
        index: obj.index,
        checksameproductincarts: obj.checksameproductincarts,
        checkstock: obj.checkstock,
        adjuststock: obj.adjuststock
      }
      vm.item = {
        data: obj.data,
        type: obj.type,
        index: 0,
        checkstock: obj.checkstock,
        checksameproductincarts: obj.checksameproductincarts,
        adjuststock: obj.adjuststock
      }
    },
    addNewButton: function (index, payload) {
      var vm = this
      if (vm.intentItems[vm.currentAlternative][0].responseinbox[0].buttons.length < 3) {
        if (payload.type == 'web_url') {
          delete payload.payload
        } else if (payload.type == 'postback' || payload.type == 'phone_number') {
          delete payload.url
        }
        vm.intentItems[vm.currentAlternative][0].responseinbox[0].buttons.push(payload)
        this.newButton = {
          title: '',
          type: 'web_url',
          url: ''
        }
        // this.$emit('input', this.bubbleMessages)
      }
      this.saveTimestamp = moment().format('x')
    },
    editButton: function (index, bindex, payload) {
      var vm = this
      if (vm.intentItems[vm.currentAlternative][0].responseinbox[0].buttons[bindex]) {
        // this.intentItems[index].value.buttons[index] = payload
        if (payload.type == 'web_url') {
          delete payload.payload
        } else if (payload.type == 'postback' || payload.type == 'phone_number') {
          delete payload.url
        }
        this.$set(
          vm.intentItems[vm.currentAlternative][0].responseinbox[0].buttons,
          bindex,
          payload
        )
        // this.$emit('input', this.bubbleMessages)
      }
      this.editTimestamp = moment().format('x')
    },
    deleteButton: function (index, bindex) {
      var vm = this
      vm.intentItems[vm.currentAlternative][0].responseinbox[0].buttons.splice(bindex, 1)
      // this.$emit('input', this.bubbleMessages)
    },
    addIntentPrefill: function (index, subindex, prefill) {
      var vm = this
      let cursorPosition = this.$refs['answer_' + index + '_' + subindex][0].$el.selectionStart

      if (vm.intentItems[vm.currentAlternative][0].responseinbox[subindex].type === 'text') {
        vm.$set(
          vm.intentItems[vm.currentAlternative][0].responseinbox[subindex],
          'text',
          [
            vm.intentItems[vm.currentAlternative][0].responseinbox[subindex].text.slice(
              0,
              cursorPosition
            ),
            '{' + prefill + '}',
            vm.intentItems[vm.currentAlternative][0].responseinbox[subindex].text.slice(
              cursorPosition
            )
          ].join('')
        )
      } else if (
        vm.intentItems[vm.currentAlternative][0].responseinbox[subindex].type == 'button'
      ) {
        vm.$set(
          vm.intentItems[vm.currentAlternative][0].responseinbox[subindex],
          'text',
          [
            vm.intentItems[vm.currentAlternative][0].responseinbox[subindex].text.slice(
              0,
              cursorPosition
            ),
            '{' + prefill + '}',
            vm.intentItems[vm.currentAlternative][0].responseinbox[subindex].text.slice(
              cursorPosition
            )
          ].join('')
        )
      }
      // this.$emit('input', this.bubbleMessages)
    },
    cancelAddFlexMessage: function () {
      this.showLineFlex = false
      this.resetFlexMessage()
    },
    saveAddFlexMessage: function () {
      var vm = this
      vm.$set(vm.intentItems[vm.currentAlternative][0].responseinbox, 0, vm.flexMessage)

      // vm.$emit('input', vm.bubbleMessages)
      vm.showLineFlex = false
      vm.resetFlexMessage()
    },
    resetFlexMessage: function () {
      this.flexMessage = {
        type: 'flex',
        altText: 'You received a message',
        contents: '{}'
      }
    },
    addVideo: function (video) {
      var vm = this
      vm.$set(vm.intentItems[vm.currentAlternative][0].responseinbox, 0, video)
      // vm.$emit('input', vm.bubbleMessages)
      vm.showVideo = false
    },

    selectIntentReplyType: function (type) {
      const vm = this

      if (type == 'text') {
        vm.$set(vm.intentItems[vm.currentAlternative][0].responseinbox, 0, {
          text: '',
          type: type
        })
      } else if (type == 'button' && vm.$store.getters.getPackage == 'premium') {
        vm.$set(vm.intentItems[vm.currentAlternative][0].responseinbox, 0, {
          text: '',
          buttons: [],
          type: type
        })
      } else if (type == 'image' && vm.$store.getters.getPackage == 'premium') {
        vm.$set(vm.intentItems[vm.currentAlternative][0].responseinbox, 0, {
          image_url: '',
          type: type
        })
      } else if (type == 'ntn_template' && vm.$store.getters.getPackage == 'premium') {
        vm.$set(vm.intentItems[vm.currentAlternative][0].responseinbox, 0, {
          image_url: null,
          title: '',
          notification_messages_frequency: '',
          type: type
        })
      } else if (type == 'generic' && vm.$store.getters.getPackage == 'premium') {
        vm.$set(vm.intentItems[vm.currentAlternative][0].responseinbox, 0, {
          data: [
            {
              image_url: null,
              title: '',
              subtitle: '',
              buttons: []
            }
          ],
          type: type
        })
      } else if (type == 'welcome_message' && vm.$store.getters.getPackage == 'premium') {
        vm.$set(vm.intentItems[vm.currentAlternative][0].responseinbox, 0, {
          type: type
        })
      } else if (type == 'viewsummary' && vm.$store.getters.getPackage == 'premium') {
        if (vm.products.length == 0) {
          return false
        }
        vm.$set(vm.intentItems[vm.currentAlternative][0].responseinbox, 0, {
          type: 'text',
          text: '{viewsummary}'
        })
      } else if (type == 'video' && vm.$store.getters.getPackage == 'premium') {
        vm.showVideo = true
      } else if (type == 'addtocart' && vm.$store.getters.getPackage == 'premium') {
        vm.showCartaddremove = true
      } else if (type == 'line_flex' && vm.$store.getters.getPackage == 'premium') {
        vm.showLineFlex = true
      } else if (
        (type == 'product_catalog' || type == 'manage_product_to_cart') &&
        vm.$store.getters.getPackage == 'premium'
      ) {
        vm.showProductCatalogMessage = true
      }
      vm.$forceUpdate()
    },
    addImage: function (index, subindex) {
      this.$set(this.intentItems[index][subindex].responsecomment[0], 'image_url', '')
    },
    deleteImage: function (index, subindex) {
      this.$delete(this.intentItems[index][subindex].responsecomment[0], 'image_url')
    },
    nextAlternative: async function () {
      var comment = cloneDeep(this.newComment)
      this.intentItems.push([comment])
      await this.$nextTick()
      this.currentAlternative = this.intentItems.length - 1
      this.randomTimestamp = moment().format('x')
    },
    onCheckboxChange: function () {
      this.$forceUpdate()
    },
    onHideComment: function () {
      this.onCheckboxChange()
    },
    onReplyComment: function () {
      this.onCheckboxChange()
    },
    onLikeComment: function () {
      this.onCheckboxChange()
    },
    handleAddProductCatalog: function (product_catalog) {
      const vm = this
      try {
        // console.log({ product_catalog })

        vm.$set(vm.intentItems[vm.currentAlternative][0].responseinbox, 0, product_catalog)
        vm.showProductCatalogMessage = false
        vm.isReplyComment = false
      } catch (error) {
        console.error(error)
      }
    },
    handleCancelProductCatalog() {
      this.showProductCatalogMessage = false
      this.isReplyComment = false
    }
  }
}
</script>

<style>
.v-window .v-window__container {
  height: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/intent/IntentComment.vue